import { MeasureActionType, PolicyPublicType } from '@/contexts/policies/Policies.interfaces'

export const POLICY_ROUTE_NAMES = {
  POLICIES: 'policies',
  POLICY_VERSION: 'policy_version',
} as const

export const MEASURE_ACTION_TYPE = {
  ...MeasureActionType,
}

export const POLICY_PUBLIC_TYPE_TRANSLATION_KEY: Readonly<Record<PolicyPublicType, string>> = {
  [PolicyPublicType.PUBLIC]: 'policies.list.public',
  [PolicyPublicType.PRIVATE]: 'policies.list.private',
}
